export default __webpack_public_path__ + "static/ProValue_1@mob-effe550bdacb3f8fd6438aea5fd29e68.webp";